export default "__VITE_ASSET__zuwPVYHO__"